<div class="modal-header">
    <h6 class="modal-title medium">{{'cropImg' | translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body profile-pic-cropper">

    <img-cropper #cropper [image]="data" [settings]="cropperSettings"></img-cropper>
    <!-- <br> -->
    <!-- <span class="result rounded" *ngIf="data.image" >
        <img  class="rounded-circle" [src]="data.image" >
    </span> -->
    <!-- <input type="file" (change)="fileChangeEvent($event)" /> -->

    <!-- <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 3" [resizeToWidth]="128"
        format="png" (imageCropped)="imageCropped($event)"></image-cropper>

    <img [src]="croppedImage" /> -->
</div>
<div class="modal-footer">
    <!-- <button class="btn btn-secondary float-left" (click)="activeModal.dismiss('Cross click')"> Close </button> -->
    <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> {{'cancel' | translate
        }}
    </button>
    <button class="btn btn-primary float-right" (click)="confirmCrop()"> {{'confirm' | translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/imageCropper/imageCropper.html